import React, { useState, useEffect, useMemo } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Link } from "react-router-dom";
import Calendar from 'react-awesome-calendar';


const events = [{
    id: 1,
    color: '#fd3153',
    from: '2022-01-02T18:00:00+00:00',
    to: '2022-01-05T19:00:00+00:00',
    title: 'This is an event'
}, {
    id: 2,
    color: '#1ccb9e',
    from: '2022-01-01T13:00:00+00:00',
    to: '2022-01-05T14:00:00+00:00',
    title: 'This is another event'
}, {
    id: 3,
    color: '#3694DF',
    from: '2022-02-05T13:00:00+00:00',
    to: '2022-02-05T20:00:00+00:00',
    title: 'This is also another event'
}];



export default function OutletProfile(props: any) {
    const [is_loading, SetIsLoading] = useState(false);
    const [Modal, SetModal] = useState({ open: false, type: '' });
    const [ViewModal, SetViewModal] = useState(false);

    useEffect(() => {
        console.log("OutletService On mount :", props);
    }, []);

    return (
        <div>
            <div className="bg-fff profile-shadow">
                <div className="row align-items-center p-3">
                    <div className="col-2 col-md-1 p-0 text-center">
                        <img
                            className="w-100 img-radius"
                            src="https://1superapp.com/uploads/images/0f2fe74047de5a35650658a3aab710b1.jpeg"
                        />
                    </div>
                    <div className="col-10 col-md-11">

                        <h5 className="  mb-1">Employee Name</h5>
                        <small>@employee</small>
                        <div className="d-md-none d-lg-block">
                            <div className="mt-3">
                                <div className="row">
                                    <div className="col-md-8 mb-3">
                                        <div className="row">
                                            <div className="col-4">
                                                <h6 className="mb-1">55</h6>
                                                <p className="m-0">Tasks</p>
                                            </div>



                                            <div className="col-4">
                                                <h6 className="mb-1">50</h6>
                                                <p className="m-0">Completed</p>
                                            </div>
                                            <div className="col-4 align-items-center">
                                                <h6 className="mb-1">5</h6>
                                                <p className="m-0">Bending</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">

                                        <h6>₹ 50000</h6>
                                        <p className="m-0">Total earnings</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-2 d-lg-none">
                    <div className="row text-center">
                        <div className="col-3">
                            <h6 className="mb-1">55</h6>
                            <p className="m-0 v-small">Tasks</p>
                        </div>
                        <div className="col-3">
                            <h6 className="mb-1">50</h6>
                            <p className="m-0 v-small">Completed</p>
                        </div>
                        <div className="col-3 align-items-center">
                            <h6 className="mb-1">5</h6>
                            <p className="m-0 v-small">Bending</p>
                        </div>
                        <div className="col-3">
                            <h6 className="mb-1">₹ 50000</h6>
                            <p className="m-0 v-small">Earnings</p>
                        </div>
                    </div>
                </div>

            </div>
            <div className="container mt-lg-5 pt-md-5">
                <div className="mt-3 card p-3">
                    <Calendar
                        events={events}
                    />
                </div>
            </div >
        </div>
    );
}